import { Price, Stack, Text } from "flicket-ui";
import { ComponentProps, ReactNode } from "react";
import Skeleton from "react-loading-skeleton";
import { useOrganization } from "~hooks";

export interface RenderFeeProps {
  price: number;
}

export type SinglePageCheckoutListItemProps = {
  title: string;
  subtitle?: ReactNode;
  price?: number;
  isLoading?: boolean;
  variant?: ComponentProps<typeof Text>["variant"];
  renderPrice?: (props: RenderFeeProps) => JSX.Element;
};

function DefaultRenderPrice({ price }: RenderFeeProps): JSX.Element {
  const { organization } = useOrganization();
  return <Price price={price} currency={organization.currency} />;
}

export const SinglePageCheckoutListItem = ({
  title,
  subtitle,
  price,
  isLoading,
  renderPrice = (props: RenderFeeProps) => <DefaultRenderPrice {...props} />,
  variant = "regular",
}: SinglePageCheckoutListItemProps) => {
  return (
    <Stack
      direction={"horizontal"}
      justifyContent="space-between"
      alignItems="flex-start"
      gap={2}
    >
      <Stack direction={"vertical"} display="flex" flex={3}>
        <Text variant={variant}>
          {isLoading ? <Skeleton height="10px" /> : title}
        </Text>
        {subtitle && (
          <Text variant="small">
            {isLoading ? <Skeleton width="60%" height="10px" /> : subtitle}
          </Text>
        )}
      </Stack>
      <Text variant={variant} flex={1} textAlign={"right"}>
        {isLoading ? <Skeleton height="10px" /> : renderPrice({ price })}
      </Text>
    </Stack>
  );
};
